import { StrictMode, type ReactNode } from 'react';

export const ConditionalStrictMode = ({
  children,
}: {
  children: ReactNode;
}) => {
  if (import.meta.env.PROD) {
    return <StrictMode>{children}</StrictMode>;
  }
  return <>{children}</>;
};
